<p-table
	[lazy]="true"
	[paginator]="true"
	[rows]="dataTable.rowsPerPage"
	[value]="data?.data"
	[totalRecords]="data?.total"
	[loading]="loading"
	(onLazyLoad)="loadData($event)"
	(onPage)="pageChange($event)"
>
	<ng-template pTemplate="caption">
		<div class="flex items-center gap-2 justify-end w-full">
			<span class="p-input-icon-left flex-grow">
				<i class="pi pi-search"></i>
				<input
					pInputText
					type="text"
					[(ngModel)]="searchTerm"
					placeholder="Buscar"
					style="width: 100%"
                    (keyup.enter)="searchData(searchTerm)"
				/>
			</span>

			<!-- 🔹 Botón PrimeNG estilizado -->
			<button
				pButton
				type="button"
				label="Buscar"
				icon="pi pi-search"
				iconPos="left"
				class="p-button-primary"
				(click)="searchData(searchTerm)"
			></button>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<ng-container *ngFor="let item of options.columns">
				<th>{{ item?.title || "" }}</th>
			</ng-container>
			<th *ngIf="!!options.actions.length"></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-item>
		<tr>
			<ng-container *ngFor="let column of options.columns">
				<td>
					<app-datatable-column
						[data]="item"
						[column]="column"
					></app-datatable-column>
				</td>
			</ng-container>
			<td *ngIf="!!options.actions.length">
				<div class="dropdown">
					<button
						class="btn btn-outline-primary dropdown-toggle"
						type="button"
						id="actionsDropdown"
						data-toggle="dropdown"
						aria-expanded="false"
					>
						<i class="fa fa-bars"></i>
					</button>
					<ul
						class="dropdown-menu shadow"
						aria-labelledby="actionsDropdown"
					>
						<li *ngFor="let action of options.actions">
							<button
								class="dropdown-item d-flex align-items-center gap-2"
								(click)="triggerEvent(action, item)"
							>
								<i
									class="fa fa-lg {{
										action?.icon
									}} text-primary"
								></i>
								{{ action.display }}
							</button>
						</li>
					</ul>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>
